export const detectFieldType = (key, sampleValue) => {
	const declaredType = (
		getSampleTypeName(sampleValue) || ""
	).toLowerCase();
	if (declaredType.includes("image")) {
		return "Image";
	}
	if (
		["file", "files", "document", "template", "signature"].some(
			(token) => declaredType.includes(token),
		)
	) {
		return "file";
	}
	if (declaredType === "textobject") {
		return "TextObject";
	}
	if (
		looksLikeImage(sampleValue) ||
		`${key}`.toLowerCase().includes("image")
	) {
		return "Image";
	}
	if (looksLikeFileCollection(sampleValue)) {
		return "file";
	}
	if ((sampleValue?.type || "").toLowerCase() === "textobject") {
		return "TextObject";
	}
	if (looksLikeObject(sampleValue)) {
		return "TextObject";
	}
	return undefined;
};

const getSampleTypeName = (value) => {
	if (!value || typeof value !== "object") return undefined;
	if (typeof value.type === "string") return value.type;
	if (typeof value?.value?.type === "string") return value.value.type;
	if (typeof value?.type?.value === "string") return value.type.value;
	return undefined;
};

const looksLikeImage = (value) => {
	const candidate = value?.value ?? value;
	if (!candidate || typeof candidate !== "object") return false;
	return (
		(candidate?.width || candidate?.height) &&
		(candidate?.src || candidate?.url || candidate?.path)
	);
};

const looksLikeFileCollection = (value) => {
	const candidate = value?.value ?? value;
	if (!candidate) return false;
	const entries = Array.isArray(candidate)
		? candidate
		: typeof candidate === "object"
			? Object.values(candidate)
			: [];
	return entries.some(
		(entry) =>
			entry &&
			typeof entry === "object" &&
			(typeof entry.type === "string" ||
				typeof entry.mimeType === "string"),
	);
};

const looksLikeObject = (value) => {
	const candidate = value?.value ?? value;
	if (!candidate) return false;
	return typeof candidate === "object";
};
